var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('list-widget', {
    attrs: {
      "title": "주문회원",
      "max-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var attrs = _ref.attrs;
        return [_c('autocomplete-member', _vm._b({
          attrs: {
            "placeholder": "전체",
            "dense": "",
            "flat": "",
            "solo": "",
            "hide-details": "",
            "clearable": ""
          },
          on: {
            "input": _vm.emit
          },
          model: {
            value: _vm.query['_member'],
            callback: function callback($$v) {
              _vm.$set(_vm.query, '_member', $$v);
            },
            expression: "query['_member']"
          }
        }, 'autocomplete-member', attrs, false))];
      }
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }